import React from 'react';
import PropTypes from 'prop-types';
import { useFela } from 'react-fela';
import { getIconSrcUrl } from '..';
import { pxToRem } from '../../../utils/size-to-rem';
export function Icon(_ref) {
  let {
    type,
    color = 'primary',
    label = ''
  } = _ref;
  const {
    css,
    theme
  } = useFela();
  const size = Number(type.split('-').pop());
  const name = type.replace(`-${size}`, '');
  const iconSrc = getIconSrcUrl({
    color,
    name,
    size,
    theme
  });
  return /*#__PURE__*/React.createElement("img", {
    width: size,
    height: size,
    src: iconSrc,
    role: label ? undefined : 'presentation',
    alt: label,
    className: css({
      width: pxToRem(size),
      height: pxToRem(size)
    })
  });
}
Icon.propTypes = {
  type: PropTypes.string.isRequired,
  color: PropTypes.string,
  label: PropTypes.string
};